// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-5fb31f90]{border-bottom:1px solid hsla(0,0%,59.2%,.12)}.multifunction-slot[data-v-5fb31f90]{position:fixed;right:1rem;bottom:4rem}", ""]);
// Exports
module.exports = exports;
